import React from 'react';
import { CollectionListProductItem } from './CollectionListProductItem';
import { Box, Grid, styled } from '@mui/material';
import useProductStocksSWR from '../../hooks/products/useProductStocks';
import { getShopifyID } from '../../utils/utils';
import { Product } from '../../models/Product';
import { CollectionGridProductItem } from './CollectionGridProductItem';

const CollectionItemWrapper = styled(Box)(({ theme }) => ({
    display: 'flex',
    width: '100%',
    flexWrap: 'wrap',
}));

const CollectionItem = styled(Box)(({ theme }) => ({
    padding: '5px',
    alignItems: 'stretch',
}));

export const CollectionGridWrapper = (props: any) => {
    const { products, handle, gridSize } = props;
    const { stocks, isLoading, isError, getDefaultStock } =
        useProductStocksSWR(products);

    return (
        <CollectionItemWrapper>
            {products.map((item) => {
                const defaultStock =
                    stocks &&
                    stocks.find(
                        (elem) =>
                            elem.productId.toString() == getShopifyID(item.id)
                    );

                return (
                    <CollectionItem
                        key={item.id}
                        sx={{ width: Number(100 / gridSize) + '%' }}
                    >
                        <CollectionGridProductItem
                            product={item}
                            handle={handle}
                            productQuantity={
                                defaultStock &&
                                getDefaultStock(
                                    defaultStock.locations,
                                    getShopifyID(item.variants.nodes[0].id)
                                )
                            }
                        />
                    </CollectionItem>
                );
            })}
        </CollectionItemWrapper>
    );
};

type ListProps = {
    products: Product[];
    handle: string;
};
